module.exports = __webpack_public_path__ + "img/developer-1.3226aaa9.png";